import { cn } from '@/lib/utils'

import { IndicatingBar } from './ui/indicating-bar/indicating-bar'
import { ProgressGuide } from './ui/progress-guide/progress-guide'
import { useProcessDocumentProgressPage } from './use-page'

export const ProcessDocumentProgressPage = () => {
  useProcessDocumentProgressPage()

  return (
    <div className={cn('relative', 'w-full', 'h-full', 'bg-slate-100', 'px-[32px] py-[100px]')}>
      <IndicatingBar />

      <ProgressGuide />
    </div>
  )
}
